import { mixin } from "@hubrise/react-components"
import styled from "styled-components"

export const Header = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-weight: 500;
  ${mixin.clickable};
`

export const Chevron = styled.span<{ $expanded: boolean }>`
  display: inline-flex;
  transition: transform 0.1s;
  transform: rotate(${({ $expanded }) => ($expanded ? "90deg" : "0deg")});
`

export const Content = styled.div`
  margin-top: 1rem;
  padding-left: 2rem;
`
